import styled from 'styled-components';
import {getToken, getPrimitive, responsive, getSpacing, getFontSize, getFontWeight, tokens} from '@tickchak/react-share/app';
import {dFlexCenter, dFlexColumn} from '../../../../../../globalVariables/GlobalFlex';
import {BGImageCenter, LIGHT_GRAY} from '../../../../../../globalVariables/GlobalVariables';

export const typeCard = styled.button`
    position: relative;
    ${dFlexColumn}
    ${dFlexCenter}
    width: 187px;
    height: 187px;
    ${responsive(getSpacing('spaceMd'), 'border-radius')};
    border: 1px solid ${LIGHT_GRAY};
    ${responsive(getSpacing('spaceLg'), 'padding')};
    ${responsive(getSpacing('spaceLg'), 'gap')};
    background-color: ${LIGHT_GRAY};
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: ${getToken('color.bg.surface.hover')};
    }
    &.selected {
        background: ${getToken('color.bg.surface.hover')};
        border: 1px solid ${getToken('color.brand.main')};
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.25);
    }
    &.disabled {
        background: ${getPrimitive('grays.gray100')};
        border-color: ${getToken('color.border.disabled')};
        color: ${getToken('color.text.disabled')};
        cursor: not-allowed;
        pointer-events: none;
    }
        &>svg {
            align-self: start;
            height: 22px;
    }
`;

export const typeIconWrapper = styled.div<{$icon?: string}>`
    width: 100%;
    height: 100%;
    ${p => p.$icon ? BGImageCenter(p.$icon, 'contain') : ''}
    ${dFlexCenter}
    &.disabled {
        opacity: 0.3;
    }
`;

export const typeLabel = styled.div`
    ${responsive(getFontSize('body'), 'font-size')};
    ${responsive(getFontWeight('medium'), 'font-weight')};
    ${responsive(getToken('color.text.secondary'), 'color')};
    align-self: flex-start;
    margin-bottom: auto;
`;

export const checkMarkWrapper = styled.div`
    position: absolute;
    bottom: 12px;
    inset-inline-start: 12px;
    ${dFlexCenter}
`;

export const checkMark = styled.div<{$active?: boolean}>`
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    ${p => p.$active ? `
        background:  ${getPrimitive('turquoise.turquoise400')}80;
        border: 1.5px solid ${getPrimitive('turquoise.turquoise400')};
    `: `
        background: ${LIGHT_GRAY};
        border: 1px solid ${getPrimitive('grays.gray500')};
    `}
    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${p=>getPrimitive(p.$active? 'turquoise.turquoise400':'grays.gray500')}80;
        transform: translate(-50%, -50%);
    }
`;

export const successCheckMark = styled.div`
    ${dFlexCenter};
    width: 16px;
    height: 16px;
    ${responsive(getSpacing('spaceXs'), 'padding')};
    border-radius: 100px;
    background: ${tokens.color.state?.success?.bg || 'var(--color-state-success-bg)'};
`;

